import { WorkGroupResponse } from 'interfaces/WorkGroups';
import { ApiService } from 'services/Api';
import { TicketsInfo } from 'typings/services/TicketsInfo';

export class PacksService {
    private readonly apiService: ApiService;
    private readonly packId: string;

    constructor(baseUrl: string, token: string, packId: string) {
        this.apiService = new ApiService(baseUrl ?? '', '', token, '');
        this.packId = packId;
    }

    public async getTicketInfo(installationsIds: number[]): Promise<TicketsInfo> {
        const response = await this.apiService.get<TicketsInfo>(
            `v1/metrics/pack/${this.packId}/tickets?installationIds=${installationsIds.join(',')}`,
        );
        return response;
    }

    public async getWorkGroups(): Promise<WorkGroupResponse> {
        const response = await this.apiService.get<WorkGroupResponse>(`v1/workgroups/pack/${this.packId}`);
        return response;
    }
}
